(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/no-active-game.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/no-active-game.js');
'use strict';

const DashedFrame = svs.tb_ui_react.dashed_frame.DashedFrame;
const NoActiveGame = () => React.createElement("div", {
  className: "padding-h-1 margin-top-0 override"
}, React.createElement(DashedFrame, null, "Ni har inga p\xE5g\xE5ende spel i laget."));
svs.arena.pages.teams.components.NoActiveGame = NoActiveGame;

 })(window);